import config from '@config';
import { TabComponent } from './enums';
import { ILottoStateBase } from './types';

const MAX_LOTTO_NUMBERS = config.app.lotto.maxLottoNumbersDrawn;

export default {
    timestamp: Date.now(), // cache buster. Could be anything that changes

    // todo we should add comment with proper leapbit format mayber here?
    /*
     * Favourites maps stores favorite numbers for each lotto game.
     * example:
     * {
     *     4: [
     *          [1, 2, 3, 5],
     *          [1, 2, 3, 8],
     *     ]
     * }
     * Note that arrays have to be sorted. Also key is lottoId because favorite
     * numbers should be shown in any event of lotto game.
     */
    favourites: {},
    areFavouritesSaving: false,
    selectedFavourites: [],
    areFavouritesFetchedUponLogin: false,
    randomNumbersAmount: Math.ceil((1 + MAX_LOTTO_NUMBERS) / 2),
    selectedSidebarComponent: TabComponent.None,
    isLoading: false,
} as ILottoStateBase;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/state.ts